exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select input{height:100%;margin:2px 0!important;font-size:.75rem}.v-select input::-moz-placeholder{color:#6b7280}.v-select input::placeholder{color:#6b7280}.v-select svg{scale:.7}", ""]);

// exports
